// packages/components/src/agent_profile/showcase/hooks/useBottomSheet.ts
import { useEffect, useMemo } from 'react';

export type BottomSheetState = 'short' | 'half' | 'full';

export function useBottomSheet(open: boolean, state: BottomSheetState, lockBody: boolean = true) {
  // Body scroll lock when open (mobile)
  useEffect(() => {
    if (!lockBody) return;
    if (typeof document === 'undefined') return;
    const body = document.body;
    if (!body) return;
    if (open) {
      const prev = body.style.overflow;
      body.style.overflow = 'hidden';
      return () => {
        body.style.overflow = prev || '';
      };
    }
  }, [open, lockBody]);

  const styles = useMemo<React.CSSProperties>(() => {
    if (!open) {
      return { transform: 'translateY(100%)' };
    }
    const height =
      state === 'full' ? '92vh' : state === 'half' ? '50vh' : '35vh'; // 'short' ~ 35vh
    return {
      height,
      transform: 'translateY(0%)',
    };
  }, [open, state]);

  return { styles };
}
